import { LoginApi } from "../interfaces/loginApi";

export class LoginService {
  constructor(private loginApi: LoginApi) {}

  async login(
    tipoDocumento: string,
    user: string,
    password: string,
    recordarme: boolean
  ): Promise<string> {
    return await this.loginApi.login(tipoDocumento, user, password, recordarme);
  }
}
